export default __webpack_public_path__ + "static/media/CNo.78-4.507246bc.jpg";